<template>
  <section class="pricing-faq-comp" :class="{'active' : articleShown}">
    <div @click="articleShown = !articleShown" class="pricing-faq-block">

      <li class="pricing-faq-title">
        <a>{{ faqTitle }}</a>
      </li>

      <transition name="t-fade-expand">
        <li class="pricing-article" v-show="articleShown">
          <article>
            <div class="wrapper">
              <p >{{ articleText }}</p>
            </div>
            <a :href="faqLink" class="link-b">{{ linkText }}</a>
          </article>
        </li>
      </transition>

    </div>
  </section>
</template>

<script>
export default {
  name: 'PricingFAQ',
  props: {
    msg: String,
    faqTitle: String,
    articleText: String,
    linkText: String,
    faqLink: String
  },
  data () {
    return {
      articleShown: false,
    }
  },
}
</script>
